import React from 'react';
import { Link } from 'react-router-dom';
import { Grid, Typography, Tooltip } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { dashboardPage } from '../../lib/utils';

const styles = {
  grid: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
  },
  link: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    padding: 'inherit',
    zIndex: 99,
  },
  container: {
    position: 'relative',
    boxShadow: '0px 4px 4px 0px #bfbfbf',
    border: '2px solid #fff',
    overflow: 'hidden',
  },
  title: {
    position: 'absolute',
    left: 0,
    right: 0,
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  value: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
  icon: {
    position: 'absolute',
    zIndex: 100,
    top: '1px',
    right: '1px',
  },
};
const containerSize = {
  default: 120,
  large: 150,
};

function DashboardCard({ name, data, size, marketId }) {
  const isLarge = size === 'large';
  const { title, titleExp, tooltip, link, actionText } = dashboardPage.data[name];
  const color = dashboardPage.colors[data.color];

  let action = actionText;
  if (actionText && Array.isArray(actionText)) {
    const value = parseInt(data.value, 10);

    if (value < 20) action = actionText[0];
    else action = actionText[1];
  }

  return (
    <Grid
      item
      xs={isLarge ? 12 : 4}
      sm={6}
      md={4}
      sx={{
        maxWidth: isLarge ? { xs: 360, sm: 280 } : 280,
      }}
      style={{
        ...styles.grid,
        cursor: link ? 'pointer' : 'default',
      }}
    >
      <Grid
        container
        direction="column"
        sx={{
          pl: 1,
          pr: 1,
          py: isLarge ? 1.2 : 0.5,
          borderRadius: 2,
        }}
        style={{
          ...styles.container,
          height: `${containerSize[size || 'default']}px`,
          borderColor: color || '#9e9e9e',
        }}
      >
        <Tooltip title={tooltip} enterTouchDelay={0}>
          <InfoIcon
            fontSize="small"
            style={styles.icon}
            sx={{
              color: 'grey.700',
              mt: isLarge ? 1.05 : 0.25,
              mr: isLarge ? 1.05 : 0.25,
            }}
          />
        </Tooltip>
        {link && (
          <Link
            style={styles.link}
            to={`/operator/markets/${marketId}/vehicles?${link}`}
            target="_blank"
          />
        )}
        <Typography
          variant="caption"
          component="div"
          sx={{
            pr: 2,
            pl: 1,
            fontSize: isLarge ? { xs: '0.75rem', sm: '0.875rem', md: '1rem' } : '0.75rem',
          }}
          style={styles.title}
        >
          {isLarge && titleExp ? titleExp : title}
        </Typography>
        <Typography
          variant={isLarge ? 'h3' : 'h5'}
          component="div"
          style={{
            color,
            textAlign: 'center',
            ...(isLarge) && styles.value,
          }}
          sx={{
            mt: isLarge ? { xs: 2, sm: 1, md: 0 } : 'auto',
            ...(isLarge) && { fontSize: { xs: '2rem', sm: '2.57rem' } },
          }}
        >
          {data.value}
        </Typography>
        {isLarge
          ? (
            <Typography
              variant="caption"
              component="div"
              sx={{ maxHeight: 28 }}
              style={{ marginTop: 'auto' }}
            >
              {action}
            </Typography>
          ) : (
            <Typography
              variant="caption"
              component="div"
              sx={{ height: 14 }}
              style={{ textAlign: 'center', marginTop: '0' }}
            >
              {data.caption}
            </Typography>
          )}
      </Grid>
    </Grid>
  );
}

export default DashboardCard;
